import { useState } from "react";
import Card from "../components/Card";

const ListItem = ({value,clear,handleClick,cssClassName}) => {
    let idx = 1;
    return (
        <>
        {value && clear && <li className={`ratings clear ${cssClassName ? cssClassName : ''}`} onClick={handleClick({})}>{value} <span>&times;</span></li>}
        {value && !clear && !handleClick && <li className={`ratings ${cssClassName ? cssClassName : ''}`} >{value}</li>}
        {value && !clear && handleClick && <li className={`ratings ${cssClassName ? cssClassName : ''}`} onClick={handleClick}>{value}</li>}
        </>
        
    );
  }
  
  export default ListItem;
  
